import React from 'react';
interface PrevSwiperArrowProps {
  className?: string;
}

const PrevSwiperArrow: React.FC<PrevSwiperArrowProps> =  ({className}) => {
  return (
       <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          height="32"
          width="32"
          aria-hidden="true"
          fill="currentcolor"
          role="img"
          focusable="false"
          className={`Svg-sc-12lgb6u-0 EQfAR ChevronLeft__SvgChevronLeft-sc-1pih41b-0 dvOXuG ${className}`}
        >
          <path d="M15.4 16.6L10.8 12l4.6-4.6L14 6l-6 6 6 6 1.4-1.4z"></path>
        </svg>
  );
};



export default PrevSwiperArrow;
